import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { MembershipPlanModel } from 'src/app/admin-panel/models/business/membership-plan.model';
import { SearchMembershipPlanModel } from 'src/app/admin-panel/models/business/search-membership-plan.model';
import { MembershipPlanService } from 'src/app/admin-panel/services/business/membership-plan.service';
import { AddOrEditMembershipPlansComponent } from './add-or-edit-membership-plans/add-or-edit-membership-plans.component';
import { DeleteMembershipPlansComponent } from './delete-membership-plans/delete-membership-plans.component';
import { TranslateService } from '@ngx-translate/core';
import { ProjectLogoMapEnum } from "../../../enums/project-logo-map.enum";
import { ProjectId } from "../../../enums/project-id.enum";
import { AddOrEditSpecialOfferComponent } from "./add-or-edit-special-offer/add-or-edit-special-offer.component";
import { SpecialOfferService } from "../../../services/business/special-offer.service";

@Component({
  selector: 'app-membership-plans',
  templateUrl: './membership-plans.component.html',
  styleUrls: ['./membership-plans.component.scss']
})
export class MembershipPlansComponent implements OnInit {
  //#region Fields
  public membershipPlanListMap: { [key: number]: MembershipPlanModel[] } = {};
  public searchMembershipPlanModelMap: { [key: number]: SearchMembershipPlanModel } = {};
  public spinnerMap: { [key: number]: boolean } = {};
  public spinner: boolean = false;
  public unsubscribe: Subject<void> = new Subject<void>();
  public totalPages : number;
  public totalRecords : number;
  public projectList: Array<{name: string, value: number}> = new Array<{name: string, value: number}>();
  public specialOfferPresent: boolean = false;
  //#endregion
  //#region Constructor
  constructor(
    private dialogService: DialogService,
    private membershipPlanService : MembershipPlanService,
    private specialOfferService: SpecialOfferService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.getAllProjects();
    this.getSpecialOffer();
  }
  //#endregion
  //#region Public Methods
  getproducts(projectId: number, searchModel: SearchMembershipPlanModel, showSpinner: boolean = true) {
    searchModel.projectId = projectId;

    this.spinnerMap[projectId] = showSpinner;
    this.membershipPlanService.getproducts(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.searchMembershipPlanModelMap[projectId].pageNumber > 1) {
            this.membershipPlanListMap[projectId] = this.membershipPlanListMap[projectId].concat(response.data)
          }
          else {
            this.membershipPlanListMap[projectId] = response.data;
          }
          this.spinnerMap[projectId] = false;
        },
        error: errorResponse => {
           this.spinnerMap[projectId] = false;
           if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });

  };
  getAllProjects() {
    this.spinner = true;
    this.membershipPlanService.getAllProjects()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.projectList = response;
          this.projectList.forEach(product => {
            this.searchMembershipPlanModelMap[product.value] = new SearchMembershipPlanModel();
            this.membershipPlanListMap[product.value] = new Array<MembershipPlanModel>();
            this.getproducts(product.value, this.searchMembershipPlanModelMap[product.value], false);
          });
          this.spinner = false;
        },
        error: errorResponse => {
          this.spinner = false;
          if (errorResponse.error) {
            this.messageService.add({ severity: 'error', summary: "Server Error", life: 2000 });
          }
        }
      });
  };
  addNewMembershipPlans(projectId: number) {
    const ref = this.dialogService.open(AddOrEditMembershipPlansComponent, {
      header: this.translate.instant('BUSINESS.ADD_MEMBERSHIP_PLAN'),
      width: '300px',
      styleClass: 'ml_200, mb_15',
      data: {
        projectId
      }
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchMembershipPlanModelMap[projectId].pageNumber = 1;
        this.getproducts(projectId, this.searchMembershipPlanModelMap[projectId]);
        let summary = this.translate.instant('BUSINESS.MEMBERSHIP_PLAN_ADDED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  editMembershipPlan(Id: string, projectId: number) {
    const ref = this.dialogService.open(AddOrEditMembershipPlansComponent, {
      data: {
        id: Id,
      },
      header: this.translate.instant('BUSINESS.EDIT_MEMBERSHIP_PLAN'),
      width: '300px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchMembershipPlanModelMap[projectId].pageNumber = 1;
        this.getproducts(projectId, this.searchMembershipPlanModelMap[projectId]);
        let summary = this.translate.instant('BUSINESS.MEMBERSHIP_PLAN_EDITED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  deleteMembershipPlan(membershipPlanId: string, projectId: number) {
    const ref = this.dialogService.open(DeleteMembershipPlansComponent, {
      data: {
        id: membershipPlanId
      },
      header: this.translate.instant('BUSINESS.DELETE_MEMBERSHIP_PLAN'),
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchMembershipPlanModelMap[projectId].pageNumber = 1;
        this.getproducts(projectId, this.searchMembershipPlanModelMap[projectId]);
        let summary = this.translate.instant('BUSINESS.MEMBERSHIP_PLAN_DELETED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  loadMoreMembershipPlans(projectId: number){

    this.searchMembershipPlanModelMap[projectId].pageNumber = this.searchMembershipPlanModelMap[projectId].pageNumber + 1;
    this.getproducts(projectId, this.searchMembershipPlanModelMap[projectId]);
  }

  addOrUpdateSpecialOffer(): void {
    const header = this.specialOfferPresent ? 'BUSINESS.UPDATE_SPECIAL_OFFER' : 'BUSINESS.CREATE_SPECIAL_OFFER';
    const ref = this.dialogService.open(AddOrEditSpecialOfferComponent, {
      header: this.translate.instant(header),
      width: '760px',
      styleClass: 'ml_200, mb_15',
      data: {
        projects: this.projectList
      }
    });
    ref.onClose.subscribe((item: any) => {
      if (item && item.removed === true) {
        this.specialOfferPresent = false;
      } else if (item) {
        this.specialOfferPresent = true;
      }
    });
  }

  public getSpecialOffer(): void {
    this.specialOfferService.getSpecialProduct()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          if (response) {
            this.specialOfferPresent = true;
          }
        }
      });
  }

  getLogoUrl(value: number) {
    if (value === ProjectId.SocialiteEvents) {
      return ProjectLogoMapEnum.SocialiteEvents;
    } else if (value === ProjectId.SocialitePOS) {
      return ProjectLogoMapEnum.SocialitePOS;
    } else {
      return ProjectLogoMapEnum.SocialiteResy;
    }
  }
  //#endregion
  //#Private Methods
  //#endregion
}
